import { UPDATE_STATUS, UPDATE_STATUSBG, SET_EQUIPMENT_ONLINE, SET_PAYMENT_MEAN_INFO, CLEAR_PAYMENT_MEAN_INFO } from '../constants';
const eventsReducer = (state, action) => {
  const defaultState = {};
  if (!state) {
    state = defaultState;
  }

  switch (action.type) {
    case UPDATE_STATUSBG:
      //console.log('🚀 ~ eventsReducer ~ action.data.params.mode', action.data.params.mode);
      //console.log('🚀 ~ eventsReducer', state[action.data.source]);
      const current = state[action.data.source];
      // console.log('🚀 ~ eventsReducer ~ current.mode:', current.mode);
      if (!current || (current.mode === 'offline' && action.data.params.mode === 'offline')) {
        return state;
      }
      const out = {
        ...state,
        [action.data.source]: {
          ...current,
          mode: action.data.params.mode,
          payment_mean: action.data.params?.payment_mean ?? null,
          controller: action.data.params?.controller,
          gateway: action.data.params?.gateway,
        },
      };
      // console.log('🚀 ~ eventsReducer ~ out:', out);
      return out;

    case UPDATE_STATUS:
      return {
        ...state,
        [action.data.source]: {
          ...state[action.data.source],
          ...action.data.params,
        },
      };
    case SET_EQUIPMENT_ONLINE: {
      const prev = state[action.source] || {};
      let mode = prev.mode;
      if (action.online) {
        // вернулась связь: снимаем режим «Отключен», актуальный режим придёт следующим get_state_background
        if (!mode || mode === 'offline') {
          mode = 'regular';
        }
      } else {
        mode = 'offline';
      }
      return {
        ...state,
        [action.source]: {
          ...prev,
          mode,
          controller: { ...prev.controller, is_online: action.online ? 1 : 0 },
        },
      };
    }
    case SET_PAYMENT_MEAN_INFO:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          payment_mean: {
            ...state[action.id].payment_mean,
            info: action.info,
          },
        },
      };
    case CLEAR_PAYMENT_MEAN_INFO:
      return {
        ...state,
        [action.id]: {
          ...state[action.id],
          payment_mean: null,
        },
      };
    default:
      return state;
  }
};

export default eventsReducer;
